import BoxIcon from "../../../../components/ui/box-icon/box-icon";
import imgAbStart from "../../../../assets/images/about-start.jpeg";
import "./about-the-beginnins.scss";
import { Fade } from "react-awesome-reveal";

const AboutTheBeginnins = () => {
  return (
    <section className="about-the-beginnins">
      <div className="about-the-beginnins__info-section">
        <Fade direction="left" duration={900} triggerOnce>
          <div className="about-the-beginnins__icon">
            <BoxIcon icon={"calendar"} size={"medium"} type={"primary"} />
          </div>
          <h2 className="about-the-beginnins__title">Gli Inizi (1997)</h2>
          <div className="about-the-beginnins__text-container">
            <p className="about-the-beginnins__text">
              L'attività di impresa che ha portato nel corso degli anni alla
              costituzione della attuale ROTOINFISSIONI SRL, ha avuto inizio a
              Conselve (PD) nel 1997 ad opera del sign. Violato Ivano.
            </p>
            <p className="about-the-beginnins__text">
              Dopo una lunga esperienza di collaborazione presso la ditta di
              famiglia, fonda la "Costruzioni Generali Violato Ivano".
            </p>
            <p className="about-the-beginnins__text">
              La Ditta artigiana si concentrava inizialmente nella installazione
              di impianti di drenaggio per l'abbassamento della falda freatica,
              specializzandosi successivamente nella formazione di micropali
              brevettando un macchinario innovativo.
            </p>
          </div>
        </Fade>
      </div>

      <div className="about-the-beginnins__img-section">
        <Fade direction="right" duration={900} delay={200} triggerOnce>
          <img
            className="about-the-beginnins__img"
            src={imgAbStart}
            alt="Fondazione di Rotoinfissioni a Conselve nel 1997"
          />
        </Fade>
      </div>
    </section>
  );
};

export default AboutTheBeginnins;
